"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleDispatcher = void 0;
var UnregistrationToken_1 = require("./UnregistrationToken");
/**
 * Simple event dispatch mechanism, maintains an array of listeners which return a particular type
 */
var SimpleDispatcher = /** @class */ (function () {
    function SimpleDispatcher() {
        var _this = this;
        this.listeners = [];
        /**
         * Register a listener
         * @param listener function to call on dispatch
         * @returns unregistration token for unsubscribing later
         */
        this.registerListener = function (listener) {
            if (!_this.listeners.find(function (l) { return l === listener; })) {
                _this.listeners.push(listener);
            }
            return new UnregistrationToken_1.UnregistrationToken(function () { return _this.unregisterListener(listener); });
        };
        /**
         * Execute all listeners with a given result
         * @param result the data to dispatch
         */
        this.dispatch = function (result) {
            if (_this.listeners && _this.listeners.length) {
                _this.listeners.forEach(function (listener) {
                    listener(result);
                });
            }
        };
        /**
         * Unregister a listener, provided to consumers wrapped in an UnregistrationToken
         */
        this.unregisterListener = function (listener) {
            var index = _this.listeners.indexOf(listener);
            if (index >= 0) {
                _this.listeners.splice(index);
            }
        };
    }
    return SimpleDispatcher;
}());
exports.SimpleDispatcher = SimpleDispatcher;
